import { clsx } from 'clsx';
import { RefObject } from 'react';

import { FontIcons } from '@monoimin/atoms/components/icons/FontIcons';
import { themes } from '@monoimin/sb-types';

interface SpoilerButtonViewProps {
  buttonRef: RefObject<HTMLButtonElement>;
  isOpen: boolean;
  buttonTitle: string;
  theme?: themes;
  className?: string | Record<string, any>;
}

const SpoilerButtonView = ({
  buttonRef,
  isOpen,
  buttonTitle,
  theme,
  className,
}: SpoilerButtonViewProps) => {
  return (
    <button
      ref={buttonRef}
      className={clsx(
        'spoiler-button ghost-link pt-5 justify-center',
        className ?? 'w-full relative mx-auto ',
        {
          '-top-6': !isOpen,
        }
      )}
      data-theme={theme}
    >
      <span data-button-text='true'>{buttonTitle}</span>
      <FontIcons
        icon='showMore'
        className={clsx({
          'transform -scale-y-100': isOpen,
        })}
      />
    </button>
  );
};

export default SpoilerButtonView;
